import script from "./CreateCompany.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCompany.vue?vue&type=script&setup=true&lang=js"

import "./CreateCompany.vue?vue&type=style&index=0&id=13dd9eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13dd9eb0"]])

export default __exports__